(function($) {
    //change quantity
    setTimeout(() => {
        $('.quantity-display').text($('input.qty[type="number"]').val());
    }, 500);

    $('.quantity-button').on('click', function() {
        let input = $('input.qty[type="number"]'),
            val = parseInt($(input).val()),
            minVal = $(input).attr('min'),
            maxVal = $(input).attr('max');
        
        if ($(this).hasClass('minus') && val > minVal) $(input).val(val - 1);
        else if ($(this).hasClass('plus') && (val < maxVal || !maxVal)) $(input).val(val + 1);
        $('.quantity-display').text($(input).val());
    });

    //change variation
    setTimeout(() => {
        let startID = $('input[name="variation_id"]').val();
        $('.variation-item[data-variation-id="' + startID + '"]').addClass('active');
    }, 500);

    $('.variation-item').on('click', function() {
        let variationName = $(this).attr('data-variation-name'),
            variationOption = $(this).attr('data-variation-option');

        $('select[name="' + variationName + '"]').val(variationOption).trigger('change');

        let thisElt = $(this);
        $('.variation-item').each(function() {
            if (!$(this).is(thisElt)) $(this).removeClass('active');
        });

        $(this).addClass('active');
    });
})(jQuery);